export enum CrudEnum {
  VIEW = "VIEW",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  ADD = "ADD"
}
